import Grid from '@material-ui/core/Grid';
import styled, { css } from "styled-components";

interface BoxIconProps {
    color?: string;
}

export const ContentList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
`;

export const ContainerFields = styled(Grid)`
    background-color: white;
    width: 100%;
    border-radius: 10px 10px 10px 10px;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    height: 100%;
`;

export const ContainerList = styled.div`
    margin: 10px;
    margin-top: 15px;
    margin-left: 5px;
    margin-right: 5px;
    overflow: auto;
`;

export const BoxIcon = styled.div<BoxIconProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #f23b5d;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    margin-right: 10px;

    div {
        display: flex;
        font-size: 13px !important;
    }

    ${props => props.color && css`
        background-color: ${props.color};
    `}
`;

export const AutomaticData = styled.span`
    line-height: 1;
    margin: 0px 2px;
    padding: 3px 5px;
    white-space: nowrap;
    border-radius: 3px;
    font-size: 13px;
    border: 1px solid rgb(238, 238, 238);
    color: rgba(51, 51, 51, 0.9);
    background-color: rgb(248, 248, 248);
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 8px 10px;
  width: 400px;
  border: 1px solid #e9ecef;
  transition: all 0.2s;
  position: relative;

  svg {
    color: #adb5bd;
    font-size: 18px;
    margin-right: 8px;
  }

  &:focus-within {
    border-color: #9337ed;
    box-shadow: 0 0 0 3px rgba(147, 55, 237, 0.1);
    
    svg {
      color: #9337ed;
    }
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 14px;
  color: #495057;

  &::placeholder {
    color: #adb5bd;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #adb5bd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    font-size: 16px;
    color: #adb5bd;
    margin-right: 0px !important;
  }
  
  &:hover {
    color: #6c757d;
  }
`;

export const ItemCountText = styled.p`
  font-size: 12px;
  color: #6c757d;
  margin-top: 2px;
  margin-left: 2px;
  text-align: left;
`;